import { ConceptCard } from "@/components/ConceptCard";
import { PageHero } from "@/components/PageHero";
import { SectionHeading } from "@/components/SectionHeading";
import { conceptGallery } from "@/data/site";
import { useI18n } from "@/i18n/I18nProvider";

export function Media() {
  const { t } = useI18n();

  return (
    <>
      <PageHero title={t("media.hero.title")} body={t("media.hero.body")} image="/concepts/verdantfall-hero.png" />

      <section className="content-band">
        <div className="section-inner">
          <SectionHeading title={t("media.gallery.title")} body={t("common.conceptNotice")} />
          <div className="concept-grid">
            {conceptGallery.map((concept) => (
              <ConceptCard key={concept.id} concept={concept} />
            ))}
          </div>
        </div>
      </section>

      <section className="content-band parchment-band">
        <div className="section-inner narrow-copy" data-reveal>
          <h2>{t("media.palette.title")}</h2>
          <p>{t("media.palette.body")}</p>
          <div className="palette-row" aria-label="Verdantfall palette samples">
            <span style={{ background: "#5FBF4A" }} />
            <span style={{ background: "#B8793B" }} />
            <span style={{ background: "#B94A3A" }} />
            <span style={{ background: "#4ABAD9" }} />
            <span style={{ background: "#E431FF" }} />
            <span style={{ background: "#3B155F" }} />
            <span style={{ background: "#62FFE7" }} />
            <span style={{ background: "#C79A3A" }} />
          </div>
        </div>
      </section>
    </>
  );
}
